import React, { ChangeEvent } from "react";
import { toast } from "react-toastify";
import { Button, Col, Form, Input, Label, Row } from "reactstrap";
import { AccountName, Continue, Email, Previous, ProjectDescription } from "../../../../../../../constants";
import VariationBox from "./VariationBox";
import { ActiveCallbackProp, BusinessSettingsFormType,  } from "../../../../../../../types/Forms";
import { useForm } from "react-hook-form";

const BusinessSettingsForm: React.FC<ActiveCallbackProp> = ({ activeCallBack }) => {
  const { register, formState: { errors }, setValue, watch, handleSubmit,} = useForm({ defaultValues: { accountName: "", email: "", description: "" },});

  const formData = watch();

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    let name = event.target.name as keyof typeof BusinessSettingsFormType;
    let value = event.target.value;
    setValue(name, value, { shouldValidate: true, shouldDirty: true });
  };

  const handleNextButton = handleSubmit(
    () => {
      if (formData.accountName !== "" && formData.email !== "" && formData.description !== "") activeCallBack(3);
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );

  return (
    <Form onSubmit={(event) => event.preventDefault()} className="needs-validation" noValidate>
      <Row className="g-3">
        <Col md="6">
          <Label>{AccountName}<span className="txt-danger">*</span></Label>
          <Input {...register("accountName", { required: "Acount name is required" })} value={formData.accountName} onChange={updateFormData} type='text' />
          {errors.accountName && <span className='text-danger'>{errors.accountName.message}</span>}
        </Col>
        <Col md="6">
          <Label>{Email}<span className="txt-danger">*</span></Label>
          <Input {...register("email", { required: "Email is required" })} type='text' placeholder='org@superrito.com' value={formData.email} onChange={updateFormData} />
          {errors.email && <span className='text-danger'>{errors.email.message}</span>}
        </Col>
        <Col xs="12">
          <Label>{ProjectDescription}</Label>
          <Input {...register("description", { required: "Description is required" })} type="textarea" rows={3} value={formData.description} onChange={updateFormData} />
          {errors.description && <span className="text-danger">{errors.description.message}</span>}
        </Col>
        <Col xs="12">
          <section className="main-upgrade">
            <div>
              <i className="fa fa-rocket" />
              <h5 className="mb-2">{"Select team size with "}<span className="txt-primary"> {"projects"}</span></h5>
              <p className="text-muted mb-2">{" Agile teams are cross-functional and made up of 5-11 on a regular basis team member."}</p>
            </div>
            <VariationBox />
          </section>
        </Col>
        <Col xs="12" className="text-end">
          <Button onClick={() => activeCallBack(1)} color="primary" className="me-2">{Previous}</Button>
          <Button color="primary" onClick={handleNextButton}>{Continue}</Button>
        </Col>
      </Row>
    </Form>
  );
};
export default BusinessSettingsForm;
